'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import CloseIcon from '@/components/icons/Close';
import Logo from '@/components/layout/Logo';
import { MemberNavigationActions } from '@/components/layout/MemberNavigation';

interface MemberMenuOverlayProps {
  onClose: () => void;
  onLogout?: () => void;
}

export default function MemberMenuOverlay({
  onClose,
  onLogout,
}: MemberMenuOverlayProps) {
  const pathname = usePathname();
  function handleHomeClick() {
    if (pathname === '/') {
      onClose();
    }
  }

  return (
    <div
      role='dialog'
      aria-modal='true'
      aria-label='Member menu'
      className='bg-sh-paper fixed inset-0 z-60 flex min-h-screen overflow-y-auto pt-8 md:hidden'
    >
      <button
        aria-label='Close member menu'
        onClick={onClose}
        className='hover:bg-sh-black/30 absolute top-3.5 right-5 flex rounded-full p-1'
      >
        <CloseIcon className='text-sh-black size-12' />
      </button>

      <div className='flex flex-1 flex-col items-center justify-start overflow-y-auto px-8 pt-16'>
        <div className='flex w-full flex-col items-center'>
          <Link
            href='/'
            aria-label='Go to homepage'
            className='shrink-0'
            onClick={handleHomeClick}
          >
            <Logo className='mb-10 h-[30px]' />
          </Link>

          <MemberNavigationActions
            onLogout={onLogout}
            onNavigate={onClose}
            className='sh-heading-3 flex-col space-y-6'
            memberButtonClassName='w-auto'
            logoutButtonClassName='w-auto'
          />
        </div>
      </div>
    </div>
  );
}
